import { User } from "@auth0/auth0-react";

// switched away from Aveni Team Super-User because it's easier to be selective about clients in production
export function claimCheck(claims?: User): boolean {
  const roleClaims = (claims?.["https://avenidetect.com/roles"] as string[] | undefined) ?? [];
  return roleClaims.includes("GPTutils User");
}
